export enum ActionTypes {
    SET_ANNOTATION = "SET_ANNOTATION",
    CLEAR_ANNOTATION = "CLEAR_ANNOTATION",
    CLEAR_ANNOTATIONS = "CLEAR_ANNOTATIONS",
    ADD_ANNOTATION = "ADD_ANNOTATION",
    UPDATE_ANNOTATION = "UPDATE_ANNOTATION",
    UPDATE_MESSAGE = "ANNOTATION/UPDATE_MESSAGE",
    DELETE_ANNOTATION = "DELETE_ANNOTATION",
    DELETE_MESSAGE = "ANNOTATION/DELETE_MESSAGE",
    CLOSE_POPUP = "CLOSE_POPUP",
    OPEN_POPUP = "OPEN_POPUP",
    RESET_POPUP_STATE = "ANNOTATION//RESET_POPUP_STATE",
    SHOW_MESSAGES = "SHOW_MESSAGES",
    HIDE_MESSAGES = "HIDE_MESSAGES",
    SAVE_ANNOTATION = "ANNOTATION//SAVE_ANNOTATION",
    UPDATE_FAKE_ANNOTATION = "ANNOTATION//UPDATE_FAKE_ANNOTATION",
    SET_INITIAL_ANNOTATIONS = "SET_INITIAL_ANNOTATIONS",
    ENTER_EDIT_MODE = "ENTER_EDIT_MODE",
    ENTER_VIEW_MODE = "ENTER_VIEW_MODE",
    MOUSE_ENTER_ANNOTATION = "MOUSE_ENTER_ANNOTATION",
    MOUSE_LEAVE_ANNOTATION = "MOUSE_LEAVE_ANNOTATION",
    SET_ATTACHMENT_IDS = "ANNOTATION//SET_ATTACHMENT_IDS",
    CHANGE_CURRENT_ATTACHMENT_ID = "ANNOTATION//CHANGE_CURRENT_ATTACHMENT_ID",
    SET_CURRENT_ATTACHMENT_ID = "ANNOTATION//SET_CURRENT_ATTACHMENT_ID",
    SET_MESSAGE_EDITOR_INFO = "ANNOTATION//SET_MESSAGE_EDITOR_INFO",
    SET_ANNOTATIONS = "ANNOTATION/SET_ANNOTATIONS",
}
